export default "__VITE_ASSET__a0458a01__"